import type { FC, RefObject } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import styled from "styled-components";

import { StickyTabs } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { useLLMTabs } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/hooks/useLLMTabs";
import { getAvailableTabsConfig } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMConsts";
import { navigateToReport } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";
import type {
    EAvailableTabs,
    IAiTrackerCampaign,
} from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

const StyledStickyTabs = styled(StickyTabs)`
    justify-content: flex-start;
    z-index: 20;

    & > .react-tabs {
        width: 100%;
        padding: 0 44px;
        max-width: unset;
    }
`;

interface ILLMReportContainerTabsProps {
    selectedCampaign: IAiTrackerCampaign;
    containerRef: RefObject<HTMLDivElement>;
}

export const LLMReportContainerTabs: FC<ILLMReportContainerTabsProps> = ({ selectedCampaign, containerRef }) => {
    const {
        params: { model },
    } = useCurrentStateAndParams();
    const { currentTab, getTabMetadataById } = useLLMTabs();

    const onTabSelection = (tabId: EAvailableTabs): void => {
        const nextTab = getTabMetadataById(tabId);
        navigateToReport(selectedCampaign, model, nextTab.id);
        containerRef?.current?.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <StyledStickyTabs
            activeTab={currentTab.id}
            onTabClick={onTabSelection}
            items={Object.entries(getAvailableTabsConfig()).map(([key, { title, badge }]) => ({
                id: key,
                title: translate(title),
                badge,
            }))}
        />
    );
};
